import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";

const selectors = {
  block: "[data-product-categories]",
};

const initSwiper = (container) =>
  new Swiper(container.querySelector(".swiper"), {
    spaceBetween: 24,
    enabled: true,

    breakpoints: {
      0: {
        slidesPerView: 1,
        slidesPerGroup: 1,
      },
      640: {
        slidesPerView: 2,
        slidesPerGroup: 2,
      },
      1024: {
        slidesPerView: 3,
        slidesPerGroup: 3,
      },
      1280: {
        slidesPerView: 4,
        slidesPerGroup: 4,
      },
    },

    on: {
      init: (swiper) => {
        swiper.el.style.opacity = '1';
      }
    },

    navigation: {
      prevEl: container.querySelector('[data-swiper-navigation="prev"]'),
      nextEl: container.querySelector('[data-swiper-navigation="next"]'),
    },

    pagination: {
      el: container.querySelector("[data-swiper-pagination]"),
    },
  });

const initBlock = (block) => {
  Swiper.use([Navigation, Pagination]);

  initSwiper(block);
};

document.addEventListener(
  "DOMContentLoaded",
  async function () {
    const blocks = document.querySelectorAll(selectors.block);

    blocks?.forEach(initBlock);
  },
  {
    once: true,
  }
);
